module.exports = __webpack_public_path__ + "static/qintel-5aae66a6a921a02c338161a190abec63.jpg";